import { Drawer } from "@components";
import { Titles } from "../../variables/Titles";

import TextForm from "../types/TextForm";

export const CustomerNameForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
  onRemove,
}) => {
  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={Titles.CustomerName}
      direction="center-right"
      parentSelector={() => document.getElementById("oracle-flow")}
    >
      <TextForm
        node={node}
        onSave={(node) => onSave(node)}
        onRemove={onRemove}
      />
    </Drawer>
  );
};
